/*
 * @Author: Scarlett Xiao
 * @Date: 2022-02-14 15:55:11
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-06-22 14:16:41
 */
export function loadBMap(funcName) {
  var script = document.createElement("script");
  // e0f484006b77be8751415194c36fefba
  script.src = "https://api.map.baidu.com/api?type=webgl&v=2.0&ak=rXAeMrbBwGdyIzhqlFuYfOkbLzk0q3Or&callback=" + funcName;
  // script.src = "http://api.map.baidu.com/api?v=2.0&ak=4SohswS24sY2IWAiMmntfpR398zEXjVm&callback=" + funcName;
  setTimeout(() => {
    document.body.appendChild(script);
  }, 0);

}